module.exports = __webpack_public_path__ + "01_mole.e6addb8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/01_mole.png
// module id = 30JN
// module chunks = 0